jQuery.fn.bstooltip = jQuery.fn.tooltip;
$.widget.bridge('uitooltip', $.ui.tooltip);
